
import { FormGroup, Input, Label, ListGroup, Row, ListGroupItem } from 'reactstrap';
import Icon from '../../common/js/icon';

import ColoredScrollbars from '../../common/js/coloredScrollbars';
import { Tooltip as ReactTooltip } from 'react-tooltip'
import { useDispatch, useSelector } from 'react-redux';
import { useEffect, useState } from 'react';
import EmailPromptModal from '../../modal/email/emailPromptModal';
import { deleteEmailPrompt, fetchPromptsList, updateEmailPrompt, updateEmailPromptAsDefault, updateUserSettings } from '../apiclient';
import { updateOffsetLimitValue } from '../../../redux/features/settings/settingslice';

const EmailPrompts = () => {

    const settings = useSelector((state) => state.settings)
    const [formal, setIsFormal] = useState(settings.preferences.default_writing_style ? settings.preferences.default_writing_style === 'formal' : true);
    const [isOpen, setIsOpen] = useState(false);
    const [emailPrompts, setEmailPrompts] = useState([]);
    const [promptDetails, setPromptDetails] = useState({})
    const [isEditPrompt, setIsEditPrompt] = useState(false)
    const userId = useSelector((state) => state.user.user.user_id);
    const [displayShowMore, setDisplayShowMore] = useState(settings?.promptsList && (settings.offsetLimitValue.offset + settings.offsetLimitValue.limit) < settings.promptsCount ? true : false);
    const dispatch = useDispatch();

    useEffect(() => {
        setEmailPrompts(settings.promptsList);
        setDisplayShowMore((settings?.promptsList && (settings.offsetLimitValue.offset + settings.offsetLimitValue.limit) < settings.promptsCount) ? true : false)
    }, [settings.promptsList])

    const toggleModal = () => {
        setIsOpen(!isOpen)
    }

    const handleEdit = (eventDetails) => {
        setIsEditPrompt(true)
        setPromptDetails(eventDetails)
        toggleModal()
    }

    const handleAddPrompt = () => {
        setIsEditPrompt(false)
        toggleModal();
    }

    const handleDelete = (promptId) => {
        dispatch(updateOffsetLimitValue({ offset: 0, limit: 50 }))
        deleteEmailPrompt(dispatch, promptId, userId)
    }

    const handleDefaultPrompt = (optionItem) => {
        const defaultPrompt = {
            "is_default": optionItem.is_default ? false : true
        }
        const promptDetails = {...optionItem}
        updateEmailPromptAsDefault(dispatch, defaultPrompt, promptDetails, userId)
    }

    const handleSubmit = () => {
        updateUserSettings({ 'default_writing_style': formal ? 'formal' : 'casual' }, userId, dispatch, 'email-prompts')
    }

    useEffect(() => {
        fetchPromptsList(dispatch, userId, settings)
    }, [settings?.offsetLimitValue?.offset])

    const handleShowMore = () => {
        let newOffset = settings.offsetLimitValue.offset + settings.offsetLimitValue.limit;
        dispatch(updateOffsetLimitValue({ offset: newOffset, limit: settings.offsetLimitValue.limit }));
    }

    return (
        <div className="email-prompts-wrapper">
            <ColoredScrollbars className="details-panel-scrollbar">
                <div className="content-panel p-1 pt-2">
                    <div className="col-md-12 col-sm-12">
                        <p className="mb-0">AI Email Writer quickly generates personalised emails for you. Use this page to set your preferred writing style and add at least one prompt to create emails that are relevant and engaging for your audience.</p>
                    </div>
                    <div className="col-md-12 col-sm-12 pt-3">
                        <label className="m-0">Default writing style</label>
                        <p className="mb-0 pt-1">
                            <fieldset className="form-group mb-0 radio-buttons">
                                <FormGroup check>
                                    <Input type="radio" id="formal" name="style" checked={formal} onChange={() => setIsFormal(true)} />
                                    <Label check for="formal">
                                        Formal
                                    </Label>
                                </FormGroup>
                                <FormGroup check>
                                    <Input type="radio" id="casual" name="style" checked={!formal} onChange={() => setIsFormal(false)} />
                                    <Label check for="casual">
                                        Casual
                                    </Label>
                                </FormGroup>
                            </fieldset>
                        </p>
                    </div>
                    <div className="col-md-12 col-sm-12">
                        <button className={"primary-btn btn-save-cancel mt-3"} onClick={() => { handleSubmit() }}>Save</button>
                    </div>
                    <div className="col-md-12 col-sm-12 pt-4">
                        <div className="d-flex justify-content-between align-items-center">
                            <h6 className="mb-0">Prompts</h6>
                            <button
                                className="primary-btn btn-save-cancel new-prompt-btn"
                                onClick={() => handleAddPrompt()}
                            >
                                New
                            </button>
                        </div>
                        <div>
                            <EmailPromptModal isOpen={isOpen} toggleModal={toggleModal} promptDetails={promptDetails} isEditPrompt={isEditPrompt} />
                            { emailPrompts?.length > 0 ? (<Row>
                                <div className='search-result list-view-panel'>
                                    <div className='result-wrapper'>
                                        <div className="result-list-container content-panel">
                                            <div className="listviewtable-block bggray lr-spaceHierachy">
                                                <div className="list-table">
                                                    <div className="list-header d-flex">
                                                        <div className="list-col align-self-center w-80"><b>Prompt name</b></div>
                                                        <div className="list-col align-self-center text-center w-20"><b>Actions</b><Icon color="#053874" size={25} icon="icon-gen-plus" className="me-2 circle-border" onClick={() => handleAddPrompt()} data-tooltip-id="new-prompt"
                                                                                            data-tooltip-hidden={!settings.preferences.hint_text}/></div>
                                                    </div>
                                                </div>
                                            </div>

                                            <ListGroup style={{ marginBottom: "10px" }}>
                                                {/* <ColoredScrollbars style={{ maxHeight: "200px" }}> */}
                                                <div>
                                                    {emailPrompts.map((optionItem) => {
                                                        return (
                                                            <ListGroupItem key={optionItem.id}>
                                                                <div className="prompt-container">
                                                                    <div className="listviewtable-block">
                                                                        <div className="list-table">
                                                                            <div className="list-tablerow d-flex">
                                                                                <div className="list-col align-self-top d-inline-flex w-80">
                                                                                    <span className='prompt-icon'></span>
                                                                                    <div>
                                                                                        <h5 className={`result-title-name mb-0 text-wrap ${optionItem.is_default ? "font-weight-bold" : ""}`}>{optionItem.title} {optionItem.is_default ? "(default)" : ""}</h5>
                                                                                    </div>
                                                                                </div>

                                                                                <div className="list-col align-self-center text-center w-20">
                                                                                    <ul className="search-button d-flex justify-content-center p-0 m-0">
                                                                                        <li
                                                                                            className="p-1"
                                                                                            data-tooltip-id="edit"
                                                                                            data-tooltip-hidden={!settings.preferences.hint_text}
                                                                                        >
                                                                                            <Icon color="#053874" size={20} icon="icon-gen-edit" className="me-1" onClick={() => { handleEdit(optionItem) }} />
                                                                                        </li>
                                                                                        <li
                                                                                            className={`default-button p-1`}
                                                                                            data-tooltip-id="set-default"
                                                                                            data-tooltip-hidden={!settings.preferences.hint_text}
                                                                                        >
                                                                                            <Icon
                                                                                                color="#053874"
                                                                                                size={20}
                                                                                                icon={optionItem.is_default ? 'icon-gen-round-filled' : "icon-gen-tick-round-outline"}
                                                                                                onClick={() => { handleDefaultPrompt(optionItem) }}
                                                                                            />
                                                                                        </li>
                                                                                        <li
                                                                                            className="p-1"
                                                                                            data-tooltip-id="delete"
                                                                                            data-tooltip-hidden={!settings.preferences.hint_text}
                                                                                            onClick={() => { handleDelete(optionItem.prompt_id) }}
                                                                                        >
                                                                                            <Icon
                                                                                                size={20}
                                                                                                icon="icon-gen-trash"
                                                                                            />
                                                                                        </li>
                                                                                        <ReactTooltip id="edit" place="bottom" type='dark' effect="solid">
                                                                                            <p className="tool-tip-sidebar">Edit</p>
                                                                                        </ReactTooltip>
                                                                                        <ReactTooltip id="set-default" place="bottom" type='dark' effect="solid">
                                                                                            <p className="tool-tip-sidebar">Set as default</p>
                                                                                        </ReactTooltip>
                                                                                        <ReactTooltip id="delete" place="bottom" type='dark' effect="solid">
                                                                                            <p className="tool-tip-sidebar">Delete</p>
                                                                                        </ReactTooltip>
                                                                                        <ReactTooltip id="new-prompt" place="bottom" type='dark' effect="solid">
                                                                                            <p className="tool-tip-sidebar">New Prompt</p>
                                                                                        </ReactTooltip>
                                                                                    </ul>
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </ListGroupItem>
                                                        )
                                                    })}
                                                </div>
                                                {/* </ColoredScrollbars> */}
                                            </ListGroup>
                                        </div>
                                    </div>
                                </div>
                            </Row>) : ( <div className="no-prompts-text pt-3 pb-3">
                                <p>You don’t have any prompts. Click “New” to create your first one.</p>
                                </div>) }
                        </div>
                    </div>
                    {emailPrompts && Object.keys(emailPrompts).length > 0 ? (
                        <div className={`show d-flex justify-content-center pt-3 pb-3 showmore-result`}>
                            {displayShowMore ? <button className="btn btn-block btn-primary" onClick={handleShowMore}>Show more</button> : ("")}
                        </div>
                    ) : (<span></span>)}
                </div>
            </ColoredScrollbars>
        </div>
    );
};

export default EmailPrompts;